import angular from "angular";
import { FieldConf, TicketRecalc } from "app/tickets/ctrls.js";
import { PrinterListModalCtrl } from "app/printers/ctrls";

import printModalTpl from "app/printers/modal.list.html";

export class MixCalculatorCtrl {
  constructor(
    R,
    $growl,
    $location,
    $timeout,
    $ticket,
    $prodConf,
    $company,
    $state,
    UserService,
    Modal,
    $secureUrlService
  ) {
    "ngInject";
    this.$growl = $growl;
    this.$timeout = $timeout;
    this.company = $company;
    this.ticket = $ticket;
    this.R = R;
    this.$state = $state;
    this.userDefaultCompany = UserService.$user.default_company;
    this.data = R.copy(this.ticket);
    this.prodConf = $prodConf;
    this.data.company = this.company
    this.prodConf.params.company = this.userDefaultCompany;
    this.isLoading = true
    this.prodConf.refresh().then(() => {
        this.fieldConf = new FieldConf(this.data, this.prodConf);
        this.isLoading = false;
    });
    this.tRecalc = new TicketRecalc(this.data, this.fieldConf);
    this.loading = {};
    this.acresStatus = "";
    this.saveDisabled = true;
    this.companyChanged = false;
    this.Modal = Modal;
    this.secureUrlService = $secureUrlService;
    this.calculateClicked = false;

    if (this.company.custom_delay !== null && this.data.delay === null) {
      this.data.delay = this.company.custom_delay;
    }

    $location.hash(""); // clear
  }

  onCompanyChange() {
    this.prodConf.params.company = this.data.company.id;
    this.data = this.R.copy(this.ticket);
    this.isLoading = true
    this.prodConf.refresh().then(() => {
        this.fieldConf = new FieldConf(this.data, this.prodConf);
        this.isLoading = false;
    });
    this.tRecalc = new TicketRecalc(this.data, this.fieldConf);
    this.calculateClicked = false
  }

  onCustomerChange() {
    this.data.freight_zone = this.data.customer.freight_zone;
  }

  onAcresModelChange() {
    this.tRecalc.acres();
    this.data.is_acres_touched = true;
  }

  onQuantityChange() {
    this.tRecalc.quantity();
    this.data.is_acres_touched = true;
  }

  handleFormulationErrors(errors) {
    this.saveDisabled = true;
    this.calc("calc", false);
  }

  handleErrors(errors) {
    if (errors.formulation) {
      this.handleFormulationErrors(errors);
    }
    this.errors = this.fieldConf.handleErrors(errors);
  }

  acresStatusCallback() {
    this.acresStatus = "";
  }

  reCalculateAcres(canReCalc) {
    if (canReCalc) {
      return;
    }
    this.data.acres = _.round(_.sum(_.map(this.data.fields, "field.acres")), 2);
    this.tRecalc.acres();
  }

  onAcresTouchChange(isChanged) {
    this.reCalculateAcres(isChanged);
  }

  onAcresChange(action) {
    if (this.data.is_acres_touched) {
      this.acresStatus = "not-updated";
    } else {
      this.acresStatus = "updated";
    }

    this.reCalculateAcres(this.data.is_acres_touched);
  }

  getData() {
    let data = angular.copy(this.data);
    data.products = _.filter(data.products, (o) => {
      return o.product;
    }); // to avoid glitches
    return data;
  }

  beforeSend() {
    let self = this;
    self.data.gals = self.data.gals === "" ? null : self.data.gals;
    self.data.lbs_gal = self.data.lbs_gal === "" ? null : self.data.lbs_gal;
    self.data.id = "mix-calculator";
  }

  calc(btn, raise_exception = true) {
    let self = this;
    let params = {};
    btn = btn || "calc";
    self.loading[btn] = true;
    self.errors = {};
    self.fieldConf.syncNutrientsToTicket();

    if (btn === "calc_clay") {
      params.calc_clay = 1;
    }
    let data = self.getData();
    params.raise = raise_exception;
    self.beforeSend();
    self.data
      .one("calc")
      .customPUT(data, null, params)
      .then(
        function (response) {
          if (btn === "calc_clay") {
            self.fieldConf.setClay(response.formulation.clay || 0);
          } else {
            let newData = response.plain();
            delete newData.products; // Do not remove last line if cals
            angular.extend(self.data, newData);
          }
          if (raise_exception) {
            self.saveDisabled = false;
          }
        },
        function (response) {
          if (response.status === 500) {
            self.$growl.error("Server Error. We could not calculate formula!");
            return;
          }
          self.handleErrors(response.data);
        }
      )
      .finally(() => (self.loading = {}, this.calculateClicked = true));
  }

  submit(close = true) {
    let self = this;
    let params = {};

    self.loading[close ? "submit" : "submitc"] = true;
    self.fieldConf.syncNutrientsToTicket();
    self.errors = {};
    let data = self.getData();

    data.products = "a";
    self.beforeSend();
    data
      .put(params)
      .then(
        function (response) {
          angular.extend(self.ticket, response);
          if (close) {
            let changed = !angular.equals(
              self.ticket.company,
              self.data.company
            );
            angular.extend(self.ticket, response);
            self.$growl.updated();
            self.$modal.close({ companyChanged: changed, newId: response.id });
          }
        },
        function (resp) {
          if (resp.status === 500) {
            self.$growl.error("Server Error. We could not calculate formula!");
            return;
          }
          self.handleErrors(resp.data);
        }
      )
      .finally(() => (self.loading = {}));
  }

  close() {
    this.$state.go("r.in.top.admin");
  }

  reset() {
    this.data = this.R.copy(this.ticket);
    this.isLoading = true
    this.prodConf.refresh().then(() => {
        this.fieldConf = new FieldConf(this.data, this.prodConf);
        this.isLoading = false;
    });
    this.tRecalc = new TicketRecalc(this.data, this.fieldConf);
    this.calculateClicked = false
  }

  print () {
    let self = this;
    let $modal = this.Modal.open({
        template: printModalTpl,
        controller: PrinterListModalCtrl,
        size: 'large',
        resolve: {
            company: () => self.ticket.company.id,
            request: () => {
                return {
                    endpoint: self.ticket.all('shipping-ticket').all('print'),
                    multiple: false
                }
            },
        }
    });

    $modal.result.then(function(){
        self.$state.go(self.$state.current, {created:false}, {reload: true});
        self.$growl.success('Added file to queue');
    });
}

  preview () {
    let self = this;
    this.secureUrlService.openInNewWindow(self.ticket.one('shipping_ticket'), self.data);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/mix_calculator/ctrls.js